module.exports = __webpack_public_path__ + "static/media/alert.247dbd27.svg";